import { Box, Button } from "@mui/material";

import TaskAltIcon from "@mui/icons-material/TaskAlt";
import LaunchIcon from "@mui/icons-material/Launch";
function NftMarketplace() {
  const CustomFeatureText = ({ text, textTitle }) => {
    return (
      <>
        <div className="custom-marketplace-text-div">
          <TaskAltIcon
            className="custom-marketplace-feature-icon"
            color="secondary"
          />
          <div>
            <p className="custom-marketplace-feature-text-title">{textTitle}</p>
            <p className="custom-marketplace-feature-text">{text}</p>
          </div>
        </div>
      </>
    );
  };
  return (
    <Box
      mt="30px"
      sx={{ boxShadow: "2", borderRadius: "20px" }}
      ml="90px"
      mr="90px"
      backgroundColor="white"
    >
      <Box
        sx={{
          mt: 1,
          ml: 3,
          mr: 3,
        }}
      >
        <div className="custom-marketplace-title-div">
          <h1 className="custom-marketplace-title-text">
            White Label NFT Marketplace
          </h1>
        </div>
        <div className="custom-marketplace-description-div">
          <h2 className="custom-marketplace-description-text">
            Create your own NFT Marketplace with help of miniOrange white-label
            NFT Marketplace solution
          </h2>
        </div>

        <div className="custom-marketplace-feature-div">
          <div style={{ width: "100%" }}>
            <CustomFeatureText
              textTitle="NFT Minting"
              text="Create NFTs from photos, videos, music, blogs, and artwork to sell them on your own NFT marketplaces"
            />

            <CustomFeatureText
              textTitle="NFT buying or selling"
              text="NFTs can be easily bought, sold, and traded in your marketplace with the help of NFT Marketplace"
            />
            <CustomFeatureText
              textTitle="Royalty Programs"
              text="A royalty program compensates the original creator of an NFT when it is resold on a marketplace"
            />
            <CustomFeatureText
              textTitle="Multichain Functionalities"
              text="Marketplace is supported by various networks like Ethereum, Polygon, Binance, etc"
            />
          </div>
          <div style={{ width: "100%" }}>
            <CustomFeatureText
              textTitle="NFT Listing"
              text="Having the ability to collect, sell, and trade NFTs as a unique pieces of digital art"
            />
            <CustomFeatureText
              textTitle="Import NFTs from other marketplaces/collection"
              text="With this feature, it is possible to import NFTs from any other on-chain marketplace"
            />
            <CustomFeatureText
              textTitle="Gas-free Minting / Lazy Minting"
              text="Create a non-fungible token (NFT) on a Blockchain without paying gas fees"
            />
            <CustomFeatureText
              textTitle="Branding"
              text="Customized your NFT Marketplace according to your brand"
            />
          </div>
        </div>
        <Button
          endIcon={<LaunchIcon />}
          fullWidth
          className="custom-color-button"
          sx={{
            fontSize: "18px",
            marginBottom: "30px",
          }}
          type="submit"
          variant="contained"
          onClick={() => {
            window.open(process.env.REACT_APP_NFT_MARKETPLACE_LINK, "_blank");
          }}
        >
          Visit the Marketplace
        </Button>
      </Box>
    </Box>
  );
}

export default NftMarketplace;
